import { css } from "@emotion/react";

export const carouselRadio = css`
  display: flex;
  margin-top: 0.81rem;
  justify-content: center;
`;
